export function ensureTrailingSlash(authority: string): string {
  return authority.endsWith('/') ? authority : `${authority}/`
}
